import Vue from 'vue'
import { Validator } from 'vee-validate'
import { Component, Prop, Inject } from 'vue-property-decorator'
import moment, { Moment } from 'moment'

@Component
export default class SectionBase extends Vue {
  // Make all Sections use the same $validator instance provided by the parent.
  @Inject()
  $validator!: Validator;

  @Prop()
  name!: string

  @Prop()
  number!: number

  @Prop()
  title!: string

  validate () {
    this.$validator.validateAll().then(() => {
      console.log(this.$validator.errors.all())
    })
  }
}
